import { RequestService } from "../../../../common/services/RequestService";
import { ADD_CUSTOMER } from "../constants";

export const addCustomer = async payload => {
  const companyId = payload.companyId;
  const customerData = payload.customerData;

  let data = {
    //Общие данные
    phone_code: customerData.phoneCode,
    phone: customerData.phoneNumber,
    email: customerData.email,
    site: customerData.site,
    profile_id: customerData.profileId,
    subject_id:
      customerData.subjectKey === "individ"
        ? 6
        : customerData.subjectKey === "physical"
        ? 5
        : 4
  };

  // Данные о банке
  if (customerData.bankAccount && customerData.bankAccount.length !== 0) {
    data["bank_account"] = customerData.bankAccount.map(item => ({
      bank_name: customerData[`bankName${item}`],
      bik: customerData[`bik${item}`],
      account_corr: customerData[`accountCorr${item}`],
      bank_account_num: customerData[`bankAccountNum${item}`]
    }));
  }

  // ИП или ЮЛ
  if (customerData.registrationDate) {
    data["registraton_date"] = customerData.registrationDate.format("YYYY-MM-DD");
  }

  if (customerData.companyAddress) {
    data["address_legal"] = customerData.companyAddress;
  }
  if (customerData.inn) {
    data["inn"] = customerData.inn;
  }
  if (customerData.kpp) {
    data["kpp"] = customerData.kpp;
  }
  if (customerData.nameLegal) {
    data["name_legal"] = customerData.nameLegal;
  }
  if (customerData.ogrn) {
    data["ogrn"] = customerData.ogrn;
  }

  if (customerData.taxSystem) {
    data["nds"] = customerData.taxSystem;
  }

  // ФЛ

  if (customerData.birthDate) {
    data["birth_date"] = customerData.birthDate.format("YYYY-MM-DD");
  }

  if (customerData.name) {
    data["name"] = customerData.name;
  }

  if (customerData.lastname) {
    data["lastname"] = customerData.lastname;
  }
  if (customerData.patronymic && !customerData.hasNoPatronymic) {
    data["patronymic"] = customerData.patronymic;
  }

  data["has_no_patronymic"] = customerData.hasNoPatronymic || false;

  if (customerData.birthPlace) {
    data["birth_place"] = customerData.birthPlace;
  }
  if (customerData.passportSeries) {
    data["passport_series"] = customerData.passportSeries;
  }

  if (customerData.passportNumber) {
    data["passport_number"] = customerData.passportNumber;
  }



  const response = await RequestService.post(ADD_CUSTOMER.replace('{company_id}', companyId), {...data});

  return response
};
